import labelsMutations from "./mutations.js";
import labelsActions from "./actions.js";
import labelsGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      labels : {}
    };
  },
  mutations: labelsMutations,
  actions: labelsActions,
  getters: labelsGetters,
};
